import React from 'react';
import './HeroSection.css';

const TILES = [
  {
    dot: '#6366F1',
    title: 'Continuous oversight',
    body: 'Runs continuously across every inspection on the project. Every report, image, and decision reviewed against your requirements as it comes in.',
    tag: 'Always on',
  },
  {
    dot: '#8B5CF6',
    title: 'Real-time monitoring',
    body: 'A defined set of operational and financial signals, watched continuously. When something behaves abnormally, you get an alert right away.',
    tag: 'With alerts',
  },
  {
    dot: '#6576ff',
    title: 'Analytics & reporting',
    body: 'Delivered two ways: live access you can log into from anywhere, and a bespoke report that lands in your inbox on a regular cadence.',
    tag: 'Live & reported',
  },
];

function HeroSection() {
  return (
    <section id="aqp-hero" className="aqp-hero">
      {/* corner glows */}
      <div className="aqp-hero__amb aqp-hero__amb--1" />
      <div className="aqp-hero__amb aqp-hero__amb--2" />
      <div className="aqp-hero__amb aqp-hero__amb--3" />

      {/* halftone dot fields */}
      <div className="aqp-hero__dots aqp-hero__dots--tr" />
      <div className="aqp-hero__dots aqp-hero__dots--bl" />

      {/* glowing edge frame */}
      <div className="aqp-hero__innerglow" />
      <div className="aqp-hero__frame aqp-hero__frame--top" />
      <div className="aqp-hero__frame aqp-hero__frame--left" />
      <div className="aqp-hero__frame aqp-hero__frame--right" />

      {/* film grain */}
      <div className="aqp-hero__grain" />

      {/* headline */}
      <div className="aqp-hero__top">
        <div className="aqp-hero__inner">
          <div className="aqp-reveal aqp-hero__badge">
            <img src={`${process.env.PUBLIC_URL}/assets/img/logo_large 1.png`} alt="Orbix" />
            <span className="aqp-hero__badge-div" />
            <span className="aqp-hero__badge-txt">Inspection Management &amp; Oversight</span>
          </div>

          <h1 className="aqp-reveal aqp-hero__h1">The AI Quality Program</h1>

          <p className="aqp-reveal aqp-hero__lede">
            Continuous, AI-driven oversight we set up and run on your inspection projects,
            with real-time signal monitoring and analytics.
          </p>
        </div>
      </div>

      {/* bottom tiles */}
      <div className="aqp-hero__tilewrap">
        <div className="aqp-hero__tileline" />
        <div className="aqp-hero__tiles">
          {TILES.map((t, i) => (
            <div key={t.title} className="aqp-reveal aqp-hero__tile">
              {i > 0 && <span className="aqp-hero__tile-div" />}
              <div className="aqp-hero__tile-head">
                <span className="aqp-hero__tile-dot" style={{ background: t.dot, boxShadow: `0 0 12px ${t.dot}` }} />
                <span className="aqp-hero__tile-title">{t.title}</span>
              </div>
              <p className="aqp-hero__tile-body">{t.body}</p>
              <span className="aqp-hero__tile-tag">{t.tag}</span>
            </div>
          ))}
        </div>

        <div className="aqp-reveal aqp-hero__strip">
          <div className="aqp-hero__strip-inner">
            <span className="aqp-hero__strip-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
              </svg>
            </span>
            <p className="aqp-hero__strip-txt">
              Configured for your project, with you involved in what gets watched and what gets delivered.
              You shape it, we run it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
